import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { adminLogin, getToken } from "@/lib/admin";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (getToken()) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await adminLogin(email.trim().toLowerCase(), password);
      toast.success("Welcome back.");
      navigate("/admin", { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.detail || "Sign in failed.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center bg-bone px-6"
    >
      <div className="w-full max-w-md">
        <div className="mb-12 text-center">
          <div className="font-display text-3xl tracking-[-0.02em] text-ink">
            still <span className="italic font-light">form</span>
          </div>
          <div className="mt-3 text-[0.7rem] tracking-[0.28em] uppercase text-charcoal">
            Editorial · Admin
          </div>
        </div>

        <form
          onSubmit={onSubmit}
          className="bg-white border border-hairline p-10 space-y-6"
          data-testid="admin-login-form"
        >
          <div className="space-y-2">
            <label className="text-[0.7rem] tracking-[0.22em] uppercase text-charcoal">
              Email
            </label>
            <input
              type="email"
              required
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="w-full border-b border-hairline bg-transparent py-2 text-ink outline-none focus:border-ink transition-colors"
            />
          </div>
          <div className="space-y-2">
            <label className="text-[0.7rem] tracking-[0.22em] uppercase text-charcoal">
              Password
            </label>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              className="w-full border-b border-hairline bg-transparent py-2 text-ink outline-none focus:border-ink transition-colors"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full mt-4 bg-ink text-bone py-3 text-[0.72rem] tracking-[0.28em] uppercase font-medium hover:bg-charcoal transition-colors disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p className="mt-8 text-center text-[0.65rem] tracking-[0.22em] uppercase text-charcoal">
          Protected area · Still Form team only
        </p>
      </div>
    </div>
  );
}
